import React, { useEffect, useMemo } from "react";
import parse from "html-react-parser";

interface EmbedCodeProps {
  embed: string;
}

export const EmbedCode: React.FC<EmbedCodeProps> = ({ embed }) => {
  useEffect(() => {
    if (!window.instgrm) return;

    window.instgrm.Embeds.process();
  }, []);

  // save code in memo to prevent useless rerenders
  const code = useMemo(
    () => (
      <>
        {parse(decodeURIComponent(embed), {
          replace(domNode) {
            if (domNode.type !== "script") return;
            if (!("attribs" in domNode)) return;

            const source = domNode.attribs.src;
            if (!source) return;

            const script = document.createElement("script");
            script.src = source;
            script.async = true;
            document.head.appendChild(script);
          },
        })}
      </>
    ),
    [embed]
  );

  return code;
};
